const OTHER_STORES = [
    "Bars/Cafes/Restaurants",
    "Duty Free",
    "Tobacconist",
    "Tobacconist with Vending Machine",
    "Vending Machine",
];
export function isOtherStore(store) {
    return OTHER_STORES.includes(store.storetype);
}
//# sourceMappingURL=isOtherStore.js.map